import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Icon, IconButton, Menu, MenuItem } from '@material-ui/core';
import PrimaryTheme from '../../Themes/Primary';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        typography: {
            padding: theme.spacing(2),
        },
    }),
);

export default function SimplePopover(props: any) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);


    };
    const handleRouteDetails = () => {

        props.getId(props.popid)
    }
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <IconButton size="small" aria-describedby={id} aria-haspopup="true" onClick={handleClick}>
                <Icon style={{

                    color: PrimaryTheme.light,
                }}>more_vert</Icon>
            </IconButton>
            {/* <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
                Open Popover
            </Button> */}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Typography className={classes.typography}>
                    <MenuItem onClick={handleRouteDetails} style={{
                        fontSize: 14
                    }}> <Icon fontSize="small" className="mr-2">visibility</Icon> View Details</MenuItem>

                </Typography>
            </Popover>
        </div>
    );
}